import { Link } from 'gatsby';
import React from 'react';

import styles from './Navigation.styles';

const Navigation = ({ isMenuOpen, closeMenu, menu }) => (
  <nav css={styles} className={`${isMenuOpen ? 'opened' : ''} desktop-menu`}>
    <div className="links">
      {menu.map((item) => (
        <div className="link" key={item.name}>
          {item.name === 'Risk reset' ? (
            <a href={item.href} onClick={closeMenu} target="_blank">
              {item.name}
            </a>
          ) : (
            <Link to={item.href} activeClassName={'selected'} onClick={closeMenu}>
              {item.name}
            </Link>
          )}
        </div>
      ))}
    </div>
  </nav>
);

export default Navigation;
